/* eslint-disable no-use-before-define */
import { cleanObject, arrayFrom, formatDate } from '../../twd'

export const toSearchParams = (values) => {
    let p = Object.assign({
        holdUnderlyingRating: 'NO',
        offeringType: ['ask-side'],
    }, values)

    p.ytwMin = p.offerYtwMin
    p.ytwMax = p.offerYtwMax

    delete p.holdCorpSectorCode
    delete p.holdCorpType

    arrayFrom(p.states).concat(arrayFrom(p.purposes)).forEach((s) => {
        let [k,v] = s.split('=')
        if (!p[k]) p[k] = []

        let arr = p[k]
        let i = arr.indexOf(v)
        if (i<0) arr.push(v)
    })
    delete p.states
    delete p.purposes

    p.holdMuniType = []
    if (p.holdMuniTypeG) p.holdMuniType.push('G')
    if (p.holdMuniTypeR) p.holdMuniType.push('R')

    p.holdTaxable = []
    if (p.holdTaxableY) p.holdTaxable.push('Y')
    if (p.holdTaxableN) p.holdTaxable.push('N')

    if (p.holdCallableInd) {
        p.holdCallableInd = ['N']
        p.holdCallFeatures = ['holdCallableInd-N']
    } else {
        delete p.holdCallableInd
    }

    if (['AND','OR'].indexOf(p.holdRatingAndOr)<0) {
        p.holdRatingAndOr = p.holdRatingAndOr===true ? 'OR' : 'AND'
    }

    delete p.holdMuniTypeG
    delete p.holdMuniTypeR
    delete p.holdTaxableY
    delete p.holdTaxableN

    p.holdMaturityMin = formatDate(p.holdMaturityMin)
    p.holdMaturityMax = formatDate(p.holdMaturityMax, true)

    return cleanObject(p)
}



// WEBPACK FOOTER //
// ./src/municipals/quick-screener/to-search-params.js